export default "__VITE_PUBLIC_ASSET__f47c13de__"